import { SET_OPEN } from '../actionsTypes/sidebar';

export const setOpen = (payload) => ({ type: SET_OPEN, payload });
